import { Chip } from "../../../../components/common/chip";
import type { ProductDto } from "../../../../api";
import { getProductLifecycleStatus } from "./product-lifecycle.utils";

export function ProductLifecycleChip({
  product,
  className,
}: {
  product: Pick<ProductDto, "active" | "notes">;
  className?: string;
}) {
  const status = getProductLifecycleStatus(product);

  if (status === "live") {
    return <Chip variant="approved" className={className}>Live</Chip>;
  }

  if (status === "discontinued") {
    return <Chip variant="rejected" className={className}>Discontinued</Chip>;
  }

  return <Chip variant="expired" className={className}>Inactive</Chip>;
}
